import dayjs from "dayjs";
import ContractorDto from "../../dto/Contractors/ContractorDto";
import MessageModel, { MessageDataConverter } from "../Message/MessageModel";
import { ContractModel } from "../Dictionaries/BitrixCompanyModel";
import { ContractDto } from "../../dto/Dictionaries/BitrixCompanyDto";

type ContractorModel = Omit<ContractorDto, "contracts" | "creatorDate" | "messages"> & {
  contracts: Array<ContractModel>;
  creatorDate: dayjs.Dayjs;
  messages: Array<MessageModel>;
};

export type CreateContractorModel = Omit<ContractorDto, "id" | "creatorDate" | "messages">;
export type UpdateContractorModel = Omit<ContractorDto, "creatorDate" | "messages">;

export class ContractorDataConverter {
  static convertContract(contract: ContractDto): ContractModel {
    return { ...contract, contractDate: dayjs(contract.contractDate) };
  }

  static convertContracts(contracts: Array<ContractDto>): Array<ContractModel> {
    return contracts.map((x) => this.convertContract(x));
  }

  static convertContractor(contractor: ContractorDto): ContractorModel {
    return {
      ...contractor,
      contracts: this.convertContracts(contractor.contracts),
      creatorDate: dayjs(contractor.creatorDate),
      messages: MessageDataConverter.convertMessages(contractor.messages),
    };
  }

  static convertContractors(contractors: Array<ContractorDto>): Array<ContractorModel> {
    return contractors.map((x) => this.convertContractor(x));
  }

  static convertContractorForUpdate(contractor: ContractorModel): UpdateContractorModel {
    return {
      ...contractor,
      contracts: contractor.contracts.map((x) => ({ ...x, contractDate: x.contractDate.format("YYYY-MM-DD") })),
    };
  }
}

export default ContractorModel;
